

















import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';

@Component
export default class DialogMobile extends Vue {
    @Prop({ default: 'white' }) public color!: string;
    @Model('change', { type: Boolean }) public showMobileScanner!: boolean;

    @Watch('show')
    public onShowChange(val: boolean) {
      this.$emit('change', val);
    }

    public close() {
      // emit to parent component to change the model
      this.$emit('change', false);
    }

    public onDialogClose() {
      // this will be called if dialog clossed by clicking outside of dialog
      this.close();
    }
}
